export default class UserAuthentication {
  constructor(localStorage) {
    this.localStorage = localStorage
  }

  isLoggedIn() {
    return Boolean(this.localStorage.getItem('token'))
  }

  getAccessToken() {
    return this.localStorage.getItem('token')
  }
}
